import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from 'store/createStore';
import CoreLayout from 'layouts/CoreLayout';
import ScrollRestoration from 'components/ScrollRestoration';


const AppContainer = () => (
	<Provider store={store}>
		<BrowserRouter>
			<ScrollRestoration>
				<CoreLayout />
			</ScrollRestoration>
		</BrowserRouter>
	</Provider>
);

export default AppContainer;
